<!-- main container -->
<div *ngIf="currentExperiment">
  <!-- main tabs -->
  <mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
    <!-- tab: inputs -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span #firstTab>Inputs</span>
      </ng-template>
      <!-- second tabs -->
      <mat-tab-group>
        <!-- tab: instructions & instruments -->
        <mat-tab label="Instructions & Instruments">
          <div class="instructions-container">
            <!-- first row -->
            <div class="first-row">
              <div>
                <mat-checkbox
                  data-testid="ic-expdetail-providechannel-checkbox"
                  [disabled]="isHistoricalRoundSelected() || legendFileName!=='' || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled"
                  [(ngModel)]="provideChannelData">Provide Channel
                  Data</mat-checkbox>
              </div>
              <div class="file-buttons-container">
                <div class="file-button-container">
                  <button mat-raised-button color="primary" data-testid="ic-expdetail-importlegend-button" (click)="validateLegendFile(legendFileInput)"
                    [disabled]="!canEditCreatedRoundInputs() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')">
                    <mat-icon>upload</mat-icon>
                    <span class="required">*</span>
                    Import Legend File
                  </button>
                  <ng-container *ngIf="(currentExperiment | icstatusIs : ['Created']) && legendFileName">
                    <button mat-raised-button color="warn" data-testid="ic-expdetail-removelegend-button" (click)="removeLegendFile()" matTooltip="Remove Legend File"
                      [disabled]="!canEditCreatedRoundInputs() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')">
                      <mat-icon>delete</mat-icon>
                      Remove Legend File
                    </button>
                  </ng-container>
                </div>
                <div class="files-container">
                  &nbsp;
                  <div class="legend-file-container">
                    <ng-container *ngIf="legendFileName">
                      <mat-icon class="success">
                        check_circle
                      </mat-icon>
                      <span>&nbsp;{{legendFileName}}</span>
                    </ng-container>
                  </div>
                </div>
                <input #legendFileInput type="file" accept=".xlsx" style="display: none;" data-testid="ic-expdetail-legendfile-input"
                  (change)="onLegendFileUpload($event)" />
                <div class="file-button-container">
                  <button mat-raised-button color="primary" data-testid="ic-expdetail-importtemplate-button" (click)="templateFilesInput.click()"
                    matTooltip="Upload a folder with 1 json file and 2 raw files"
                    [disabled]="!canEditCreatedRoundInputs() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')">
                    <mat-icon>upload</mat-icon>
                    <span class="required">*</span>
                    Import Template Files
                  </button>
                  <ng-container *ngIf="(currentExperiment | icstatusIs : ['Created']) && templateFileNames.length > 0">
                    <button mat-raised-button color="warn" data-testid="ic-expdetail-removetemplate-button" (click)="removeTemplateFiles()"
                      matTooltip="Remove Template Files"
                      [disabled]="!canEditCreatedRoundInputs() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')">
                      <mat-icon>delete</mat-icon>
                      Remove Template Files
                    </button>
                  </ng-container>
                </div>
                <div class="template-files-container">
                  <ng-container *ngIf="templateFileNames.length > 0">
                    <div class="template-file-row" *ngFor="let fileName of templateFileNames;">
                      <mat-icon class="success">
                        check_circle
                      </mat-icon>
                      <span>{{fileName}}</span>
                    </div>
                  </ng-container>
                </div>
                <input #templateFilesInput type="file" webkitdirectory multiple style="display: none;" data-testid="ic-expdetail-templatefiles-input"
                  (change)="onTemplateFilesUpload($event)" />
              </div>
              <div class="progress-message" *ngIf="isHistoricalRoundSelected()">
                Historical round selected. Instrument slots are view-only.
              </div>
              <div class="instruments-container">
                <div class="instrument-groups-container">
                  <b>CC Instrument Groups:</b>
                  <app-group-select [groups]="instrumentGroups"
                    [disabled]="!canEditInstrumentList() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')"
                    [groupIdProp]="'instrumentGroupId'" [groupDisplayProp]="'name'" [groupItemsProp]="'instruments'"
                    [itemIdProp]="'instrumentId'" [itemDisplayProp]="'instrumentSerial'"
                    (groupSelected)="onSelectGroup($event)" (groupRemoved)="onRemoveSelectedGroup($event)" (itemSelected)="onSelectItem($event)" (itemRemoved)="onRemoveSelectedItem($event)"
                    [selectedItems]="selectedInstruments">
                  </app-group-select>
                  <b>Type an Instrument Serial Number:</b>
                  <mat-form-field appearance="outline" class="instrument-serial-field" subscriptSizing="dynamic">
                    <mat-label>Instrument Serial Number</mat-label>
                    <input matInput type="text" [(ngModel)]="customSerialNumber" data-testid="ic-expdetail-serialnumber-input"
                      [disabled]="!canEditInstrumentList() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')" />
                  </mat-form-field>
                  <div class="button-container">
                    <button mat-raised-button class="success-button" data-testid="ic-expdetail-addinstrument-button" (click)="onAddInstrument()"
                      [disabled]="!canEditInstrumentList() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')">
                      <mat-icon>add</mat-icon>
                      Add
                    </button>
                  </div>
                </div>
                <div class="instrument-selected-container">
                  <b>Instruments selected:</b>
                  <div class="selected-instruments-list">
                    <div class="instrument-table-header">
                      <div class="header-cell serial-col">Instrument</div>
                      <div class="header-cell action-col">Remove</div>
                      <div class="header-cell status-col">LUT</div>
                      <div class="header-cell status-col">Factory Calibration</div>
                      <div class="header-cell upload-col">Sync LUT</div>
                    </div>
                    <div *ngFor="let instrument of selectedInstruments" class="instrument-row">
                      <div class="instrument-serial-number serial-col">{{ instrument.instrumentSerial }}</div>
                      <div class="instrument-cell action-col">
                        <button class="remove-instrument-btn" mat-stroked-button color="warn" (click)="removeInstrument(instrument)" data-testid="ic-expdetail-removeinstrument-button"
                          matTooltip="Remove instrument"
                          aria-label="Remove instrument"
                          [disabled]="!canEditInstrumentList() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')">
                          <mat-icon>delete</mat-icon>
                          Remove
                        </button>
                      </div>
                      <div class="instrument-cell status-col">
                        <span class="status-tag" [class.available]="instrument.hasLUTFile" [class.missing]="!instrument.hasLUTFile"
                          [matTooltip]="instrument.hasLUTFile ? 'LUT file available' : 'LUT file not found'">
                          LUT
                        </span>
                      </div>
                      <div class="instrument-cell status-col">
                        <span class="status-tag" [class.available]="instrument.hasFactoryCalibrationFile" [class.missing]="!instrument.hasFactoryCalibrationFile"
                          [matTooltip]="instrument.hasFactoryCalibrationFile ? 'Factory Calibration file available' : 'Factory Calibration file not found'">
                          FC
                        </span>
                      </div>
                      <div class="instrument-cell upload-col" *ngIf="!instrument.hasLUTFile">
                        <button class="sync-device-btn" mat-raised-button color="primary" data-testid="ic-expdetail-uploadlut-button"
                          (click)="syncDevice(instrument)">
                          Upload LUT
                        </button>
                      </div>
                      <div class="instrument-cell upload-col" *ngIf="instrument.hasLUTFile"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- second row -->
            <div class="second-row">
              <h2>Default settings</h2>
              <span>They can be changed on a case by case basis if needed</span>
              <div class="row">
                <label for="incubation">Incubation</label>
                <mat-icon color="primary"
                  matTooltip="How many seconds to wait after the cassette is inserted before taking the picture. Must be 0 or greater than 9.">information</mat-icon>
                <div class="separator"></div>
                <mat-form-field appearance="outline" class="default-settings-field" subscriptSizing="dynamic">
                  <input matInput appIntegerOnly type="number" name="incubation" id="incubation" data-testid="ic-expdetail-incubation-input"
                    [(ngModel)]="incubation" min="10"
                    [disabled]="!canEditCreatedRoundInputs() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')" />
                  <span matSuffix class="seconds-suffix">seconds</span>
                </mat-form-field>
              </div>
              <div class="error-message" [class.hidden]="incubation >= 10 || incubation === 0">
                <span>Incubation must be greater than 9 or be 0</span>
              </div>
              <div class="row">
                <label for="delay">Delay</label>
                <mat-icon color="primary" matTooltip="How many seconds to wat in between images">information</mat-icon>
                <div class="separator"></div>
                <mat-form-field appearance="outline" class="default-settings-field" subscriptSizing="dynamic">
                  <input matInput appIntegerOnly type="number" name="delay" id="delay" [(ngModel)]="delay" min="1" data-testid="ic-expdetail-delay-input"
                    [disabled]="!canEditCreatedRoundInputs() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')" />
                  <span matSuffix class="seconds-suffix">seconds</span>
                </mat-form-field>
              </div>
              <div class="error-message" [class.hidden]="delay >= 0">
                <span>Delay must be greater or equal than 0</span>
              </div>
              <div class="row">
                <label for="numberOfImages">Number Of Images</label>
                <div class="separator"></div>
                <mat-form-field appearance="outline" class="default-settings-field" subscriptSizing="dynamic">
                  <input matInput appIntegerOnly type="number" name="numberOfImages" id="numberOfImages" data-testid="ic-expdetail-numimages-input"
                    [(ngModel)]="numberOfImages" min="0"
                    [disabled]="!canEditCreatedRoundInputs() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')">
                </mat-form-field>
              </div>
              <div class="error-message" [class.hidden]="numberOfImages >= 0">
                <span>Number of Images must be greater or equal than 0</span>
              </div>
              <div class="separator"></div>
              <div class="actions-container">
                <button mat-raised-button color="primary" data-testid="ic-expdetail-save-button" (click)="save()"
                  [disabled]="!canEditCreatedRoundInputs() || isSaveDisabled() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')">Save</button>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Sequence" [disabled]="legendData.length === 0 || !legendData[0].legendDataId">
          <ic-sequence [experiment]="currentExperiment!" [legendData]="legendData"
            [legendInstructions]="legendInstructions" (onChangeSetReady)="onChangeSetReady($event)"
            (onChangeSequenceSaved)="onChangeSequenceSaved()"
            (onLoadPreviousSequence)="onLoadPreviousSequence()"></ic-sequence>
        </mat-tab>
      </mat-tab-group>
    </mat-tab>
    <!-- tab: in progress -->
    <mat-tab label="In Progress"
      [disabled]="(currentExperiment | icstatusIs : ['Created']) && (icRoundService.isInLastRound$ | async)">
      <div class="in-progress-container">
        <div class="adjust-legend-container">
          <button mat-raised-button color="primary" data-testid="ic-expdetail-adjustlegend-button" (click)="adustLegend()">Adjust Legend</button>
          <button mat-raised-button color="primary"
            data-testid="ic-expdetail-analyzeimages-button"
            [disabled]="currentImages <= 0 || !(icRoundService.isInLastRound$ | async) || (currentExperiment | icstatusIs : ['AnalyzingImages','Complete']) || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus') || currentExperiment.isCancelled"
            (click)="analyzeImages()">Analyze
            Images</button>
          <ng-container *ngIf="!areAllImagesAnalyzed()">
            <button mat-raised-button data-testid="ic-expdetail-refresh-button" (click)="getTestResults(false)" color="primary">
              <mat-icon>refresh</mat-icon>
              Refresh now
            </button>
            <span>Last updated: {{lastUpdateTime | date :'shortTime'}}</span>
          </ng-container>
        </div>
        <div class="progress-message" *ngIf="isHistoricalRoundSelected()">
          Historical round selected. Instrument replacements are view-only.
        </div>
        <ng-container *ngIf="(icRoundService.isInLastRound$ | async)">
          <div class="ready-message" *ngIf="(currentExperiment | icstatusIs : ['Ready'])">
            Experiment is Ready. Sofia2 instruments are each showing cassette instructions. This data is updated every
            60
            seconds
          </div>
          <div class="progress-message"
            *ngIf="(currentExperiment | icstatusIs : ['InProgress']) && !areAllImagesAnalyzed()">
            Experiment is in progress. Sofia2 instruments are each showing cassette instructions. This data is updated
            every 60 seconds
          </div>
          <div class="analyze-images-message"
            *ngIf="(currentExperiment | icstatusIs : ['InProgress']) && areAllImagesAnalyzed()">
            Please click on "Analyze Images" when desired start the image processing in the cloud.
          </div>
        </ng-container>

        <div class="instrument-block">
          <div class="total-container">
            <span>General Progress Bar: {{currentImages}}/{{totalImages}} Image sets uploaded</span>
            <div class="progressbar-container">
              <div class="progressbar-value" [style.width.%]="currentImages * 100 / totalImages"></div>
            </div>
          </div>
        </div>
        <div class="instrument-block" *ngFor="let instrument of selectedInstruments; let i = index">
          <div class="instrument-container">
            <div class="replace-instrument-container">
              <div>
                <span>Instrument </span>
                <span *ngIf="i < 9">0</span>
                <span>{{i + 1}}: </span>
                <span>{{instrument.instrumentSerial}} - Sequence:
                  {{instrument.currentImages}}/{{instrument.totalImages}} - {{instrument.currentExtraImages}} Extra
                </span>
              </div>
              <div class="separator"></div>
              <button mat-raised-button color="primary" [attr.data-testid]="'ic-expdetail-replace-button-' + i" (click)="replaceInstrument(instrumentOrders[i])"
                [disabled]="!canReplaceInstrument() || !(currentRoles | hasAnyICRoles : ['ICWRITER'] : currentExperiment : 'IsAnyStatus')">Replace
                Instrument</button>
            </div>
            <div class="progressbar-container">
              <div class="progressbar-value"
                [style.width.%]="instrument.currentImages! * 100 / instrument.totalImages!">
              </div>
            </div>
            <!-- History / Replaced Instruments Progress Bars -->
            <ng-container *ngIf="instrument.history && instrument.history.length > 0">
              <div *ngFor="let histInst of instrument.history" class="replaced-instrument-wrapper">
                <div class="replaced-instrument-label">
                  <span>{{histInst.instrumentSerial}} (replaced)
                    <span *ngIf="histInst.replacementDate" style="font-size: 0.9em; color: #666; margin-left: 5px;">
                      - {{formatReplacementDate(histInst.replacementDate)}}
                    </span>
                    <span *ngIf="histInst.roundNumber" style="font-size: 0.9em; color: #666; margin-left: 5px;">
                      - Round {{histInst.roundNumber}}
                    </span>
                    - Sequence: {{histInst.currentImages}}/{{histInst.totalImages}} - {{histInst.currentExtraImages}}
                    Extra
                  </span>
                </div>
                <div class="progressbar-container">
                  <div class="progressbar-value"
                    [style.width.%]="histInst.currentImages! * 100 / histInst.totalImages!">
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </mat-tab>
    <!-- tab: analyzing images -->
    <mat-tab label="Analyzing Images"
      [disabled]="(currentExperiment | icstatusIs : ['Created','Ready','InProgress']) && (icRoundService.isInLastRound$ | async)"
      (click)="analyzeImages()">
      <div class="analyze-container">
        <div class="reload-container">
          <button mat-raised-button data-testid="ic-expdetail-refreshanalyze-button" (click)="getImageAnalysis(false)" color="primary"
            [disabled]="((currentExperiment | icstatusIs : ['Complete']) && inProgressImagesProcessed === 0 ) || currentExperiment.isCancelled">
            <mat-icon>refresh</mat-icon>
            Refresh now
          </button>
          <span>Last updated: {{lastUpdateTime | date :'shortTime'}}</span>
        </div>
        <ng-container>
          <div class="processing-container">
            <span>
              General Progress Bar: {{displayedAnalyzedImageSetCount}}/{{totalImageSetsToAnalyze}} Image sets being analyzed
              <span *ngIf="excludedImagesProcessed > 0">
                ({{excludedImagesLegend}})
              </span>
            </span>
            <div class="progressbar-container">
              <div class="progressbar-value" [style.width.%]="imageAnalysisProgressPercentage">
              </div>
            </div>
          </div>
          <div class="summary-table-container mat-elevation-z1" *ngIf="showImageAnalysisResults">
            <mat-table [dataSource]="imageAnalysisResultRows" data-testid="ic-expdetail-analyze-results-table">
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                <mat-cell *matCellDef="let row">{{row.status}}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="numberOfImageSets">
                <mat-header-cell *matHeaderCellDef>Number of Image sets</mat-header-cell>
                <mat-cell *matCellDef="let row">{{row.numberOfImageSets}}</mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="imageAnalysisResultColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: imageAnalysisResultColumns"></mat-row>
            </mat-table>
          </div>
          <div *ngIf="showImageAnalysisResults">
            <span>Link to view the results and images in Data Fusion <a
                [href]="inProgressImagesProcessed > 0 ? null : fusionLink"
                [ngClass]="{ 'disabled-link': inProgressImagesProcessed > 0}" target="_blank">Images Analyzed</a></span>
          </div>
          <button *ngIf="showImageAnalysisResults"
            class="download-report" mat-raised-button data-testid="ic-expdetail-downloadreport-button" (click)="downloadReport()" color="primary">Download Report</button>
        </ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>
  <!-- cancel experiment button -->
  <button
    *ngIf="(currentExperiment | icstatusIs : ['Ready','InProgress','AnalyzingImages']) && !currentExperiment.isCancelled"
    mat-raised-button color="warn" data-testid="ic-expdetail-cancel-button" (click)="cancelExperiment()" class="cancel-btn">Cancel Experiment</button>
</div>